import { ViewChild } from '@angular/core';
import { Component, ElementRef, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Form } from 'models/forms/form';
import { SystemModule } from 'shared/constant';
import SignaturePad from 'signature_pad';

@Component({
  selector: 'app-signature-popup',
  templateUrl: './signature-popup.component.html',
  styleUrls: ['./signature-popup.component.css']
})
export class SignaturePopupComponent implements OnInit {
  @Input() systemModule;
  @Input() selectedForm;
  @Input() formType;
  @Input() sidePanelData;
  @Input() isApplyORSave;
  rotateImageDirection = 0;
  rotateImageClass = 'rotate-image';
  typeSignature: string = '';
  imageSignature: any = null;
  selectedTypo = '';
  signaturePadMap: Map<number, SignaturePad> = new Map();
  activeTab = 1;
  @ViewChild('signatureCanvas') signatureCanvas!: ElementRef<HTMLCanvasElement>;
  private context!: CanvasRenderingContext2D;
  private isDrawing = false;
  onboardingModule:number = SystemModule.OnBoarding;
  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    this.typeSignature = this.sidePanelData?.title;
    if (this.selectedForm.controlValue != null && this.selectedForm.controlValue != ""
      && this.selectedForm.controlValue != undefined) {
      var obj = JSON.parse(this.selectedForm.controlValue);
      if (obj.type == 'text') {
        this.activeTab = 1;        
        this.typeSignature = obj.textValue;
      }
      else if (obj.type == 'signature') {
        this.activeTab = 2;
      }
      else if (obj.type == 'image') {
        this.activeTab = 3;
        this.imageSignature = obj.value;
      }
    }
  }

  ngAfterViewInit(): void {
    const canvas = this.signatureCanvas.nativeElement;
    this.context = canvas.getContext('2d') as CanvasRenderingContext2D;

    if (!this.context) {
      console.error('Canvas context is not available.');
      return;
    }

    this.context.lineWidth = 2;
    this.context.lineCap = 'round';
    this.context.strokeStyle = '#000';

    canvas.addEventListener('mousedown', this.startDrawing.bind(this));
    canvas.addEventListener('mousemove', this.draw.bind(this));
    canvas.addEventListener('mouseup', this.stopDrawing.bind(this));
    canvas.addEventListener('mouseleave', this.stopDrawing.bind(this));

    const image = new Image();
    image.onload = () => {
      this.context.clearRect(0, 0, canvas.width, canvas.height); // Clear canvas first
      this.context.drawImage(image, 0, 0, canvas.width, canvas.height); // Draw the image
    };

    if (this.selectedForm != null && this.selectedForm.controlValue != null && this.selectedForm.controlValue != "") {
      var obj = JSON.parse(this.selectedForm.controlValue);
      if (obj.type == 'signature') {
        this.activeTab = 2;
        image.src = obj.value;
      }
    }
  }

  private startDrawing(event: MouseEvent): void {
    this.isDrawing = true;
    const { offsetX, offsetY } = event;
    this.context.beginPath();
    this.context.moveTo(offsetX, offsetY);
  }

  private draw(event: MouseEvent): void {
    if (!this.isDrawing) return;

    const { offsetX, offsetY } = event;
    this.context.lineTo(offsetX, offsetY);
    this.context.stroke();
  }

  private stopDrawing(): void {
    if (this.isDrawing) {
      this.isDrawing = false;
      this.context.closePath();
    }
  }

  clearCanvas(): void {
    const canvas = this.signatureCanvas.nativeElement;
    this.context.clearRect(0, 0, canvas.width, canvas.height);
  }

  rotateImage() {
    this.rotateImageDirection = this.rotateImageDirection < 360 ? this.rotateImageDirection + 90 : 90;
    this.rotateImageClass = `rotate-image-${this.rotateImageDirection}`
  }

  clearImage() {
    this.imageSignature = null;
    this.rotateImageClass = 'rotate-image';
    this.rotateImageDirection = 0;
  }

  onFileSelect(event) {
    let reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      let file = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.imageSignature = reader.result;
      };
    }
  }

  close() {
    this.activeModal.close(false);
  }

  convertTextToBase64() {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');

    if (!context) {
      console.error('Canvas context not available');
      return '';
    }

    canvas.width = 500;
    canvas.height = 150;

    context.fillStyle = '#000000';
    context.font = '700 48px "adobe-handwriting-ernie"';
    context.textAlign = 'left';
    context.textBaseline = 'middle'; 

    context.fillText(this.typeSignature, 20, canvas.height / 2);

    return canvas.toDataURL('image/png');
  }

  async convertImageToBase64(): Promise<string> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'Anonymous';
      img.src = this.imageSignature;

      img.onload = () => {
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');

        if (!context) {
          reject('Canvas context is not available.');
          return;
        }

        if (this.rotateImageDirection === 90 || this.rotateImageDirection === 270) {
          canvas.width = img.naturalHeight; 
          canvas.height = img.naturalWidth;
        } else {
          canvas.width = img.naturalWidth;
          canvas.height = img.naturalHeight;
        }

        context.translate(canvas.width / 2, canvas.height / 2);
        context.rotate((this.rotateImageDirection * Math.PI) / 180);

        if (this.rotateImageDirection === 90) {
          context.drawImage(img, -img.naturalWidth / 2, -img.naturalHeight / 2);
        } else if (this.rotateImageDirection === 270) {
          context.drawImage(img, -img.naturalWidth / 2, -img.naturalHeight / 2);
        } else {
          context.drawImage(img, -img.naturalWidth / 2, -img.naturalHeight / 2);
        }

        const base64String = canvas.toDataURL('image/jpeg', 0.8);
        resolve(base64String);
      };

      img.onerror = (error) => {
        reject('Failed to load the image: ' + error);
      };
    });
  }

  isCanvasEmpty(canvas) {
    const blankCanvas = document.createElement('canvas');
    blankCanvas.width = canvas.width;
    blankCanvas.height = canvas.height;

    return canvas.toDataURL('image/png') === blankCanvas.toDataURL('image/png');
  }

  applySignature() {
    if (this.activeTab == 1) {
      if (this.typeSignature != null && this.typeSignature.length > 0) {
        var obj = { type: 'text', value: this.convertTextToBase64(), textValue: this.typeSignature };
        this.selectedForm.controlValue = JSON.stringify(obj);
        this.activeModal.close(true);
      }
    }
    else if (this.activeTab == 2) {
      const canvas = this.signatureCanvas.nativeElement;
      if (!this.isCanvasEmpty(canvas)) {
        var _obj = { type: 'signature', value: canvas.toDataURL('image/png') };
        this.selectedForm.controlValue = JSON.stringify(_obj);
        this.activeModal.close(true);
      }
    }
    else if (this.activeTab == 3) {
      if (this.imageSignature != null && this.imageSignature != undefined) {
        this.convertImageToBase64()
          .then((base64Image) => {
            var obj = { type: 'image', value: base64Image };
            this.selectedForm.controlValue = JSON.stringify(obj);
            this.activeModal.close(true);
          })
          .catch((error) => {
            console.error('Error converting image to Base64:', error);
          });
      }
    }

    
  }
}
